import { createAction } from '@reduxjs/toolkit';

import { LOAD_TICKETS } from './ticketsConst';

export const loadTickets = createAction(LOAD_TICKETS);
